import { PaginationDefaultsModel } from '../models/pagination-defaults.model';

export const PaginationDefaults: PaginationDefaultsModel = {
  size: 10,
  pageNumber: 0,
  offset: 0,
  totalCount: 0,
};
